
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { A11y, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import Slide1 from '../../images/slider/slide-4.jpg';



/* heroTeam */



const Hero3 = () => {

    // const ClickHandler = () => {
    //     window.scrollTo(10, 0);
    // }


    return (
        <section className="wpo-hero-slider-s3">
            <Swiper className="swiper-container" modules={[Navigation, A11y, Pagination]}
                spaceBetween={0}
                slidesPerView={1}
                loop={true}
                speed={1800}
                parallax={true}
                navigation={false}
                pagination={{
                    clickable: true,
                    el: '.swiper-pagination',
                    type: 'fraction',
                    renderFraction: (currentClass, totalClass) => {
                        return `<span className="${currentClass}"></span> / <span className="${totalClass}"></span>`;
                    },
                }}
            >
                <SwiperSlide>
                    <div className="slide-inner slide-bg-image" style={{
                        backgroundImage: `url(${Slide1})`
                    }}>
                        <div className="container">
                        <div className="slide-content">
                            <div className="slide-sub-title">
                                <h2>Home, Kitchen Supplies</h2>
                            </div>
                            <div className="sub-title">
                                {/* <p>From concept to creation, we deliver tailored construction, design, and decor solutions that blend innovation with practicality. Collaborative, detail-driven, and budget-conscious—crafting spaces as unique as you.</p> */}
                                {/* <Link onClick={ClickHandler} to="/about" className="theme-btn">Explore Our Work</Link> */}
                            </div>
                        </div>
                        </div>
                    </div>
                </SwiperSlide>
                {/* <SwiperSlide>
                    <div className="slide-inner slide-bg-image" style={{
                        backgroundImage: `url(${Slide2})`
                    }}>
                        <div className="slide-content">
                            <div className="slide-sub-title">
                                <h2>Designing For Today,
                                    Building For Tomorrow</h2>
                            </div>
                            <div className="sub-title">
                                <p>Blaze is a trailblazing architecture agency renowned for its innovative
                                    approach to design, where creativity meets functionality.</p>
                                <Link onClick={ClickHandler} to="/about" className="theme-btn">Explore Our Work</Link>
                            </div>
                        </div>
                    </div>
                </SwiperSlide> */}
                {/* <SwiperSlide>
                    <div className="slide-inner slide-bg-image" style={{
                        backgroundImage: `url(${Slide3})`
                    }}>
                        <div className="slide-content">
                            <div className="slide-sub-title">
                                <h2>Designing For Today,
                                    Building For Tomorrow</h2>
                            </div>
                            <div className="sub-title">
                                <p>Blaze is a trailblazing architecture agency renowned for its innovative
                                    approach to design, where creativity meets functionality.</p>
                                <Link onClick={ClickHandler} to="/about" className="theme-btn">Explore Our Work</Link>
                            </div>
                        </div>
                    </div>
                </SwiperSlide> */}
              
                <div className="swiper-pagination"></div>
            </Swiper>
        </section>
    );
};

export default Hero3;
